import { render, staticRenderFns } from "./InsurancesPlanDetailsInfo.vue?vue&type=template&id=551460de&scoped=true&"
import script from "./InsurancesPlanDetailsInfo.vue?vue&type=script&lang=js&"
export * from "./InsurancesPlanDetailsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551460de",
  null
  
)

export default component.exports